import { IProjectStage } from "../app/modules/project";

const stageGates = [
    {
        id: 'project_stage_0',
        stageGate: "SG 0",
        stageGateName: "Stage 0",
        subTitle: "Problem Framing & Strategic Intent",
        purpose: "Define why the project exists and confirm it is a real, prioritised problem aligned to strategy.",
        completionGuide: "Fill in all required fields (*) and as many optional fields as possible to build a comprehensive project initiation case. Hover over the info icons for detailed guidance on what to include in each field."
    },
    {
        id: 'project_stage_1',
        stageGate: "SG 1",
        stageGateName: "Stage 1",
        subTitle: "Option Development & Need Confirmation",
        purpose: "Define demand, needs, options, and strategic alignment (NT, 2018; NT, 2026).",
        completionGuide: "Build upon SG0 findings to define comprehensive project scope, analyze demand patterns, establish outcome-based objectives, and validate strategic positioning through SWOT analysis."
    },
    {
        id: 'project_stage_2',
        stageGate: "SG 2",
        stageGateName: "Stage 2",
        subTitle: "Strategic Resourcing Decision Engine",
        subText: "<p class='mb-0'>NT BFI 2026 · IFISA · CBA/CEA · ISO 9001 · GTAC</p><p class='mb-0'>'What is the most feasible, affordable, and value-for-money option under real-world constraints?'</p>",
    },
    {
        id: 'project_stage_3',
        stageGate: "SG 3",
        stageGateName: "Stage 3",
        subTitle: "Decision Intelligence Dashboard",
        subText: "<p class='mb-0'>NT BFI 2026 · IFISA · ISO 9001 Quality Gate</p>",
    },
    {
        id: 'project_stage_4',
        stageGate: "SG 4",
        stageGateName: "Stage 4",
        subTitle: "Final Investment Decision Engine",
        subText: "<p class='mb-0'>NT BFI 2026 · IFISA · CBA/CEA · ISO 9001 Final Validation Gate</p>",
        subDescription: {
            title: "Final Investment Decision Engine",
            description: "This is the final investment decision engine for the project.",
            items: ["NT Infrastructure Planning Framework (BFI 2026)", "Infrastructure Fiscal Sustainability Assessment (IFISA)", "Cost-Benefit Analysis (CBA) / Cost-Effectiveness Analysis (CEA)", "ISO 9001 Quality Management System (final validation gate)"]
        }
    },
    {
        id: 'project_stage_5',
        stageGate: "SG 5",
        stageGateName: "Stage 5",
    },
    {
        id: 'project_stage_6',
        stageGate: "SG 6",
        stageGateName: "Stage 6",
    },
    {
        id: 'project_stage_7',
        stageGate: "SG 7",
        stageGateName: "Stage 7",
    },
    {
        id: 'project_stage_8',
        stageGate: "SG 8",
        stageGateName: "Stage 8",
    },
    {
        id: 'project_stage_9',
        stageGate: "SG 9",
        stageGateName: "Stage 9",
    },
];



const defaultStageGate = [
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_0",
        dn_stage: "Project Initiation",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_1",
        dn_stage: "Infrastructure Planning",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_2",
        dn_stage: "Strategic Resourcing",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_3",
        dn_stage: "Preparation Briefing Prefeasibility",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_4",
        dn_stage: "Concept and Viability feasibility",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_5",
        dn_stage: "Design Development",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_6",
        dn_stage: "Design Documentation",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_7",
        dn_stage: "Works",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_8",
        dn_stage: "Handover",
    },
    {
        active_gate: 0,
        additional_check: "na",
        dk_stage: "project_stage_9",
        dn_stage: "Completion",
    },
]

const getStageGate = (stageId: string) => {
    return stageGates.find(gate => gate.id === stageId);
}
const getStageGateName = (stageId: string) => {
    return stageGates.find(gate => gate.id === stageId)?.stageGateName;
}
export { stageGates, getStageGate, getStageGateName };

export const mergeStagesWithDefault = (stages: IProjectStage[]) => {
    const stagesMap = new Map<string, IProjectStage>();
    stages.forEach(stage => {
        stagesMap.set(stage.dk_stage, stage);
    });

    const mergedStages = defaultStageGate.map(defaultStage => {
        const matchingStage = stagesMap.get(defaultStage.dk_stage);
        if (matchingStage) {
            return {
                ...defaultStage,
                ...matchingStage,
                dn_stage: matchingStage.dn_stage || defaultStage.dn_stage,
            };
        }
        return defaultStage;
    });

    const activeGateIndex = mergedStages.findIndex(s => s.active_gate === 1);
    return mergedStages.map((stage, index) => {
        let status = "pending"; // default status
        if (activeGateIndex === -1) {
            status = "pending";
        } else if (index < activeGateIndex) {
            status = "completed";
        } else if (index === activeGateIndex) {
            status = "active";
        } else {
            status = "upcoming";
        }
        return {
            ...stage,
            dk_stage_status: status === "completed" ? "stage_status_2" :
                status === "active" ? "stage_status_3" :
                    "stage_status_1",
            dn_stage_status: status === "completed" ? "Completed" :
                status === "active" ? "In Progress" :
                    "Pending",
        };
    });
};
